import { Client } from "@stomp/stompjs";
import SockJS from "sockjs-client";
import { getToken } from "../utils/auth";

class WhatsappWebSocketService {
  client = null;

  connectWS() {
    const backendUrl = process.env.REACT_APP_BACKEND_URL || "";
    const url = backendUrl.endsWith('/') 
      ? `${backendUrl}beyondleadz/notifications` 
      : `${backendUrl}/beyondleadz/notifications`;
    console.log("Connecting WhatsApp STOMP: ", url);
    return new Promise((resolve, reject) => {
      // Use existing tokens in local storage
      const token = getToken();
      
      const stompClient = new Client({
        webSocketFactory: () => new SockJS(url),
        connectHeaders: {
          Authorization: `Bearer ${token}`
        },
        reconnectDelay: 5000,
        heartbeatIncoming: 4000,
        heartbeatOutgoing: 4000,
        debug: (str) => console.log('WA STOMP: ', str),
        onConnect: () => {
          stompClient.reconnectDelay = 5000; // Reset backoff on successful connect
          resolve(stompClient);
        },
        onStompError: reject,
        onWebSocketError: reject,
        onWebSocketClose: () => {
          // Exponential backoff up to ~60 seconds
          if (stompClient.reconnectDelay < 60000) {
            stompClient.reconnectDelay = stompClient.reconnectDelay * 2;
          }
        }
      });

      this.client = stompClient;
      stompClient.activate();
    });
  }

  subscribe(topic, callback) {
    if (!this.client || !this.client.connected) return null;

    return this.client.subscribe(topic, (msg) => {
      console.log("WA STOMP Received from " + topic + ": ", msg.body);
      callback(msg.body);
    });
  }

  disconnect() {
    if (this.client) this.client.deactivate();
  }
}

export default new WhatsappWebSocketService();
